export default "__VITE_ASSET__nNDAZyGQHNsrGEt2PvMGZA__"